import { render, staticRenderFns } from "./IndividualDealPageWidget.vue?vue&type=template&id=6bb45a84&scoped=true"
import script from "./IndividualDealPageWidget.vue?vue&type=script&lang=js"
export * from "./IndividualDealPageWidget.vue?vue&type=script&lang=js"
import style0 from "./IndividualDealPageWidget.vue?vue&type=style&index=0&id=6bb45a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb45a84",
  null
  
)

export default component.exports